var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImpactReportBadge(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 220 220",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1, .st2, .st3, .st4, .st5, .st6, .st7, .st8 {\n        isolation: isolate;\n      }\n\n      .st0, .st3, .st9, .st6, .st7 {\n        font-family: GerTT-Bold, GerTT;\n        font-weight: 700;\n      }\n\n      .st0, .st3, .st6, .st7 {\n        font-size: 31.6px;\n      }\n\n      .st1, .st4, .st5, .st8 {\n        font-family: GerTT-Medium, GerTT;\n        font-size: 11.3px;\n        font-weight: 500;\n      }\n\n      .st10 {\n        fill: none;\n        stroke: #000;\n        stroke-width: .4px;\n      }\n\n      .st11 {\n        fill: #fff;\n      }\n\n      .st3 {\n        letter-spacing: 0em;\n      }\n\n      .st9 {\n        font-size: 32px;\n      }\n\n      .st4 {\n        fill: #00a5ae;\n      }\n\n      .st5 {\n        fill: #f7941e;\n      }\n\n      .st6 {\n        letter-spacing: 0em;\n      }\n\n      .st7 {\n        letter-spacing: 0em;\n      }\n\n      .st8 {\n        fill: #b1d34a;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 110,
    cy: 110,
    r: 110
  }), /*#__PURE__*/React.createElement("image", {
    className: "st2",
    width: 1200,
    height: 298,
    transform: "translate(53.8 157.5) scale(0)",
    xlinkHref: "impact_report_badge-1.png"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st7",
    transform: "translate(50 101.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "IM")), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(88.7 101.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "P")), /*#__PURE__*/React.createElement("text", {
    className: "st0",
    transform: "translate(107.7 101.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A")), /*#__PURE__*/React.createElement("text", {
    className: "st6",
    transform: "translate(130.6 101.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "C")), /*#__PURE__*/React.createElement("text", {
    className: "st0",
    transform: "translate(153.9 101.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T"))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st7",
    transform: "translate(46.6 129.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "REP")), /*#__PURE__*/React.createElement("text", {
    className: "st7",
    transform: "translate(109.1 129.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O")), /*#__PURE__*/React.createElement("text", {
    className: "st7",
    transform: "translate(135.3 129.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "R")), /*#__PURE__*/React.createElement("text", {
    className: "st0",
    transform: "translate(157.2 129.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T"))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st8",
    transform: "translate(22.4 96.1) rotate(-77.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E"))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st8",
    transform: "translate(23.8 89.5) rotate(-73.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "N"))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st8",
    transform: "translate(26.4 81) rotate(-67.8)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "V"))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st8",
    transform: "translate(29.6 73.6) rotate(-63.6)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I"))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st8",
    transform: "translate(31.4 69.9) rotate(-59.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "R"))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st8",
    transform: "translate(35.3 63.1) rotate(-53.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O"))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st8",
    transform: "translate(41.2 55.1) rotate(-48.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "N"))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st8",
    transform: "translate(47 48.5) rotate(-41.6)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "M"))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st8",
    transform: "translate(54.5 41.8) rotate(-36.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E"))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st8",
    transform: "translate(60 37.8) rotate(-32)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "N"))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st8",
    transform: "translate(67.5 33.1) rotate(-26.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T"))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st8",
    transform: "translate(73 30.3) rotate(-22.2)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A"))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st8",
    transform: "translate(80.9 27.1) rotate(-18)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "L"))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(90.2 24.4) rotate(-12.3)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2022"))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st5",
    transform: "translate(97.5 23) rotate(-6.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S"))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st5",
    transform: "translate(104.4 22.1) rotate(-.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O"))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st5",
    transform: "translate(114.3 21.9) rotate(5.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "C"))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st5",
    transform: "translate(122.7 22.7) rotate(9.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I"))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st5",
    transform: "translate(126.8 23.3) rotate(12.3)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A"))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st5",
    transform: "translate(135 25.1) rotate(18)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "L"))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(144.2 28.3) rotate(23.6)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2022"))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st4",
    transform: "translate(151 31.2) rotate(29.2)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "G"))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st4",
    transform: "translate(159 35.7) rotate(34.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O"))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st4",
    transform: "translate(166.8 41.3) rotate(40.2)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "V"))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st4",
    transform: "translate(172.9 46.6) rotate(45.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E"))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st4",
    transform: "translate(177.6 51.4) rotate(49.8)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "R"))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st4",
    transform: "translate(182.7 57.5) rotate(55.3)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "N"))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st4",
    transform: "translate(187.7 64.7) rotate(60.8)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A"))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st4",
    transform: "translate(191.9 72.3) rotate(66.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "N"))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st4",
    transform: "translate(195.3 80.4) rotate(72)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "C"))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st4",
    transform: "translate(197.9 88.4) rotate(76.3)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E"))), /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 47.5,
    y1: 145.6,
    x2: 174.5,
    y2: 145.6
  })), /*#__PURE__*/React.createElement("text", {
    className: "st9",
    transform: "translate(70 69.2)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2024")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpactReportBadge);
export default __webpack_public_path__ + "static/media/impact_report_badge.93114695e95a49350f67f3bb8b26555d.svg";
export { ForwardRef as ReactComponent };